import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Send, Paperclip } from 'lucide-react';

export function ChatInput({ input, setInput, sending, uploading, fileRef, onSend, onFileUpload }) {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); onSend(); }
  };

  return (
    <div className="border-t border-slate-200 p-2 bg-white shrink-0">
      <div className="flex items-center gap-1.5">
        <button onClick={() => fileRef.current?.click()} className="p-1.5 hover:bg-slate-100 rounded transition-colors shrink-0" disabled={uploading} data-testid="support-attach-btn">
          <Paperclip className="w-4 h-4 text-slate-400" />
        </button>
        <input type="file" ref={fileRef} className="hidden" onChange={onFileUpload} />
        <Input
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={uploading ? 'Uploading...' : 'Type a message...'}
          className="flex-1 h-8 text-xs rounded-md border-slate-200"
          disabled={sending || uploading}
          data-testid="support-chat-input"
        />
        <Button
          onClick={onSend}
          disabled={!input.trim() || sending}
          size="sm"
          className="h-8 w-8 p-0 bg-[#0047AB] hover:bg-[#003580] rounded-md shrink-0"
          data-testid="support-send-btn"
        >
          <Send className="w-3.5 h-3.5" />
        </Button>
      </div>
    </div>
  );
}
